import React, { createContext, useContext, useEffect, useState } from 'react'
import posthog from '@/integrations/tracking/posthog/PostHogClient'

type FeatureFlags = Record<string, string | boolean | undefined>

const FeatureFlagsContext = createContext<FeatureFlags>({})

export const FeatureFlagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flags, setFlags] = useState<FeatureFlags>({})

  useEffect(() => {
    const updateFlags = () => {
      const allFlags: FeatureFlags = {}
      for (const key of posthog.featureFlags.getFlags()) {
        allFlags[key] = posthog.getFeatureFlag(key)
      }
      setFlags(allFlags)
    }

    // Register only once
    posthog.onFeatureFlags(updateFlags)

    return () => {
      // No posthog.offFeatureFlags available yet
      // Cleanup not possible unless they add it
    }
  }, [])

  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
}

export const useFeatureFlag = (flagName: string): string | boolean | undefined => {
  const flags = useContext(FeatureFlagsContext)
  return flags[flagName]
}
